<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-summary`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M41 29a1 1 0 011 1v13.929a2 2 0 01-2.809 1.829L35 43.905l-4.191 1.853A2 2 0 0128 43.928V30a1 1 0 011-1h12zM39 4a2 2 0 011.995 1.85L41 6l-.001 18.999h-4L37 8H9v33h15v4H7a2 2 0 01-1.995-1.85L5 43V6a2 2 0 011.85-1.995L7 4h32zm-1 29h-6v7.858l3-1.327 3 1.327V33zM26 23a1 1 0 011 1v1.5a1 1 0 01-1 1H13a1 1 0 01-1-1V24a1 1 0 011-1h13zm7-9a1 1 0 011 1v1.5a1 1 0 01-1 1H13a1 1 0 01-1-1V15a1 1 0 011-1h20z"/></svg>
</template>
<script>

export default {
  name: 'IconSummary',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
